import { FC } from 'react'
import { If, Then } from 'react-if'

import { Col, Span } from 'components'
import { Controller } from 'react-hook-form'
import { COLORS } from 'utils'

import {
  InputLabelCustom,
  ITextAreaCustom,
  TextareaAutosizeCustom
} from './TextArea.styles'

interface ITextArea extends ITextAreaCustom {
  disabled?: boolean
  label?: string
  control?: any
  errors?: any
  required?: boolean
  formValue?: string
  minRows?: number
  placeholder?: string
  maxLength?: number
  count?: number
  limitCount?: number
  value?: string
  maxRows?: number
  maxWidth?: string
}

const TextArea: FC<ITextArea> = ({
  disabled = false,
  count,
  control,
  errors,
  formValue,
  label,
  marginBottom,
  maxLength,
  marginLeft,
  marginRight,
  marginTop,
  required,
  value,
  width,
  minRows,
  placeholder,
  limitCount = 1000,
  maxRows,
  maxWidth,
}) => {
  const hasError = errors && errors[formValue || label.toLowerCase()]
  const error = hasError && errors ? errors[formValue] : null

  return (
    <Col
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      marginTop={marginTop}
    >
      <InputLabelCustom>
        {label.charAt(0).toUpperCase() + label.slice(1)}
      </InputLabelCustom>
      {control ? (
        <Controller
          control={control}
          name={formValue}
          rules={{ required }}
          render={({ field }) => (
            <>
              <TextareaAutosizeCustom
                {...field}
                disabled={disabled}
                maxLength={maxLength}
                maxWidth={maxWidth}
                width={width}
                minRows={minRows}
                maxRows={maxRows}
                placeholder={placeholder}
              />
              <If condition={field.value && Boolean(limitCount)}>
                <Then>
                  <Span
                    textAlign="right"
                    color={field?.value?.length === limitCount ? COLORS.error : COLORS.black}
                    text={`${field?.value?.length}/${limitCount}`}
                  />
                </Then>
              </If>
            </>
          )}
        />
      ) : (
        <>
          <TextareaAutosizeCustom
            value={value}
            disabled={disabled}
            maxWidth={maxWidth}
            maxRows={maxRows}
            maxLength={maxLength}
            width={width}
            minRows={minRows}
            placeholder={placeholder}
          />
          {count > 0 && (
            <Span
              textAlign="right"
              color={count === limitCount ? COLORS.error : COLORS.black}
              text={`${count}/${limitCount}`}
            />
          )}
        </>
      )}
      {hasError && (
        <Span
          text={error?.message || 'Campo obrigatório'}
          color={COLORS.error}
        />
      )}
    </Col>
  )
}

export default TextArea
